import axios from 'axios'
import store from '../store'

export default {
    getKams: (period) => axios.post('/admin/rrhh/kams', {period: period}),
    getSupports: (period, kam_id) => axios.post('/admin/rrhh/supports', {period: period, kam_id: kam_id}),
    getCollaborators: (period, kam_id, support_id) => axios.post('/admin/rrhh/collaborators', {period: period, kam_id: kam_id, support_id: support_id}),
    
    getCustomers: (period) => axios.post('/admin/rrhh/customers', {period: period}),
    getPeriods: () => axios.get('/admin/rrhh/periods'),

    getCollaboratorsReport: (filters) => axios.post('/admin/rrhh/collaborators-report', {filters: filters}),
    getEmployers: () => axios.post('/admin/rrhh/employers', {}),
    getEmployees: () => axios.post('/admin/rrhh/employees', {}),
}